import React, { useContext, useEffect, useState } from 'react';
import { Container, Col, Button, Form, Modal, Spinner } from 'react-bootstrap';
import $ from 'jquery';
import { AppContext } from '../App';

export const PaymentMethods = () => {
	const { accessToken, user, setAuthForm, link, payMethods, setPayMethods, getPayMethodLoad, postCall } = useContext(AppContext);

	const [newPayModel, setNewPayModel] = useState(false);
	useEffect(() => {
		if (!newPayModel) {
			setSelectedPay();
		}
	}, [newPayModel]);
	const [editPay, setEditPay] = useState(false)

	const [addPaymentLoad, setAddpaymentLoad] = useState(false);
	const [nameReqErr, setNameReqErr] = useState(false);
	const addPaymentMethod = (e) => {
		e.preventDefault();
		let pay = e.target.name.value;
		if (pay === "") {
			setNameReqErr(true);
			setTimeout(() => { setNameReqErr(false) }, 5000);
		}
		if (pay !== "" && selectedPay === undefined) {
			setAddpaymentLoad(true);
			postCall('api/pm/add/payment/method/', {
				name: pay,
			}).then((response) => {
				setAddpaymentLoad(false);
				setPayMethods(response.data);
				setNewPayModel(false);
			}).catch((err) => {
				setAddpaymentLoad(false);
			});

		} else if (pay !== "" && selectedPay !== undefined) {
			setAddpaymentLoad(true);
			postCall('api/pm/edit/payment/method/', {
				name: pay,
				payment_id: selectedPay.id.substring(1),
			}).then((response) => {
				setAddpaymentLoad(false);
				setPayMethods(response.data);
				setNewPayModel(false);
				setSelectedPay();
			}).catch((err) => {
				setAddpaymentLoad(false);
			});
		}
	}
	const [selectedPay, setSelectedPay] = useState();
	const selectedPayM = (payId) => {
		setSelectedPay({ id: payId, name: payMethods[payId].name });
		$('#pay_m_name').val(payMethods[payId].name);
		setNewPayModel(true);
	}
	const [changeStatLoad, setChangeStatLoad] = useState(false);
	const [changeStatPayId, setChangeStatPayId] = useState();
	const changePayMStatus = (pyid, paystst) => {
		setChangeStatLoad(true);
		setChangeStatPayId(pyid);
		postCall('api/pm/edit/payment/method/status/', {
			status: paystst,
			payment_id: pyid.substring(1),
		}).then((response) => {
			setChangeStatLoad(false);
			setPayMethods(response.data);
			setChangeStatPayId();
		}).catch((err) => {
			setChangeStatLoad(false);
			setChangeStatPayId();
		});
	}
	return (
		<div className='container-fluid'>
			<div className="bgp flex-wrap p-2 br-3 mb-2 align-items-center justify-content-between" >
				<span className='text-white' >{getPayMethodLoad ? (<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>) : 'Payment Methods'}</span>
				<Button onClick={() => {
					setNewPayModel(true);
					setEditPay(false);
				}} className="btn-t1"  ><i className="bi bi-plus-circle"></i> Add new</Button>
			</div>
			{
				payMethods !== undefined ? (
					Object.keys(payMethods).length > 0 ? (
						Object.keys(payMethods).map((payM, pay_i) => (
							<div className="closed-item p-2 br-3 flex-wrap align-items-center justify-content-between mb-2 bgs1 bdr2"  >
								<span className="tp2 f16">{payMethods[payM].name}</span>
								<div className='flex-wrap justify-content-end gap-1' >
									<Button onClick={() => {
										selectedPayM(payM);
										setEditPay(true);
									}} className="btn-t1-r" ><i className="bi bi-pencil-square"></i> Edit</Button>
									{
										changeStatPayId !== undefined && changeStatLoad && changeStatPayId === payM ? (
											<Button className="please-wait-spinner" disabled><Spinner animation="border" size="sm" /></Button>
										) : (
											payMethods[payM].status ? (
												<Button onClick={() => { changePayMStatus(payM, false) }} className="btn-disable" ><i className="bi bi-eye-slash"></i> Disable</Button>
											) : (
												<Button onClick={() => { changePayMStatus(payM, true) }} className="btn-enable" ><i className="bi bi-eye-slash"></i> Enable</Button>
											)
										)
									}
								</div>
							</div>

						))
					) : 'Nothing created yet'
				) : ''
			}
			<Modal size="xl" show={newPayModel} backdrop="static" onHide={() => { setNewPayModel(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>{editPay ? 'Update' : 'Add New'} Payment Method</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form onSubmit={addPaymentMethod} >
						<Form.Group className="mb-3">
							<Form.Label>Name {nameReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Control name='name' autoFocus="on" defaultValue={selectedPay !== undefined ? selectedPay.name : ''} className="shadow-none br-2" />
						</Form.Group>
						<div className='d-grid'>
							{
								addPaymentLoad ? (
									<Button className="please-wait-spinner" disabled><Spinner animation="border" size="sm" /> Please wait...</Button>
								) : (
									<Button type="submit" className="btn-t1">SAVE</Button>
								)
							}
						</div>
					</Form>
				</Modal.Body>
				<Modal.Footer></Modal.Footer>
			</Modal>
		</div>
	)
}